import { authAPI } from '../api';

export const changePassword = async (request: { 
  currentPassword: string; 
  newPassword: string; 
  confirmPassword: string 
}) => {
  return authAPI.changePassword(request);
};

